import React, {useEffect, useState} from 'react';
import {Note} from "types/Note";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    note: Note | null
    show: boolean
    onDelete?: (note: Note) => any
    onDeleteFail?: (note: Note, error: unknown) => any
    onCancel?: () => any
}

function DeleteNote(props: Props) {
    const {note, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(note?.title || 'this note');
    const {mutateAsync: deleteNote, isLoading} = useMutation(ngage.notes.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(note) setName(note.title)
    }, [note]);

    async function handleDeleteNote() {
        if (note) {
            try {
                await deleteNote(note.id)
                await invalidate('notes.all')

                notify("success", "Note Deleted", `${note.title} has been permanently removed`)
                if (onDelete) onDelete(note)
            } catch (error) {
                notify("error", "Note Not Deleted", `${note.title} could not be removed`)
                if (onDeleteFail) onDeleteFail(note, error)
            }
        }
    }

    function handleCancel() {
        if (!isLoading && onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Note"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteNote}
            onCancel={handleCancel}
        />
    );
}

export default DeleteNote;